import AuthLayout from '../layouts/Auth.layout';
import useAsync from '@/hooks/useAsync';
import Link from '@/components/Link';

import Form, { Props as FormProps } from '@/components/Form';

import { useNavigate, useSearchParams } from 'react-router-dom';
import { signinAuthUser } from '@/services/firebase';
import { useAuth } from '@/components/auth';
import { Box } from '@mui/material';
import { useEffect } from 'react';

interface LoginFormValues {
  email: string;
  password: string;
}

export default function LoginPage() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { execute, loading: loadingSignin, error } = useAsync(signinAuthUser);
  const redirect = searchParams.get('redirect');
  const { user, loading: userLoading } = useAuth();

  const loading = loadingSignin || userLoading;

  useEffect(() => {
    if (user && !userLoading) {
      if (redirect) {
        navigate(redirect);
      } else {
        navigate('/');
      }
    }
  }, [user, userLoading, navigate, redirect]);

  const onSubmit: FormProps<LoginFormValues>['onSubmit'] = (values) => {
    execute(values.email, values.password);
  };

  return (
    <AuthLayout title="loginTitle" description="loginDescription">
      <Form
        error={error?.message as string}
        loading={loading}
        fields={[
          { name: 'email', label: 'Email address', type: 'text-field', options: { fullWidth: true, required: true } },
          {
            name: 'password',
            label: 'Password',
            type: 'text-field',
            options: { fullWidth: true, type: 'password', required: true },
          },
        ]}
        onSubmit={onSubmit}
      />

      <Box sx={{ my: 3, textAlign: 'right' }}>
        <Link variant="subtitle2" to="/forgot-password">
          Forgot password?
        </Link>
      </Box>
    </AuthLayout>
  );
}
